"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _pruductShades = require("./pruductShades");
Object.keys(_pruductShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pruductShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pruductShades[key];
    }
  });
});
